import { render } from "./side-panel-group.vue?vue&type=template&id=1a915e47&scoped=true"
import script from "./side-panel-group.vue?vue&type=script&lang=js"
export * from "./side-panel-group.vue?vue&type=script&lang=js"

import "./side-panel-group.vue?vue&type=style&index=0&id=1a915e47&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a915e47"],['__file',"src/components/admin-dashboard/panels/side-panel-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a915e47"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a915e47', __exports__)) {
    api.reload('1a915e47', __exports__)
  }
  
  module.hot.accept("./side-panel-group.vue?vue&type=template&id=1a915e47&scoped=true", () => {
    api.rerender('1a915e47', render)
  })

}


export default __exports__